import { Component } from '@angular/core';
import { ScenarioImageService } from '../../../../services/scenario-image/scenario-image.service';
import { ApplicationStateService } from '../../../../services/application.state.service';
import { TrackingService } from '../../../../services/tracking.service';
import { QrCodeService } from '../../../../services/qr-code/qr-code.service';
import { AbstractScenarioPanelComponent } from '../../../../panels/abstract.scenario-panel.component';
import { Router } from '@angular/router';
import { DoorService } from '../../../../services/door/door.service';
import {CustomerService} from "../../../../services/customer/customer.service";
import {DoorTypeValidationService} from "../../../../services/doorTypeValidation/door-type-validation.service";

@Component({
  selector: 'app-scenario-images',
  templateUrl: './scenario-images.component.html',
})
export class ScenarioImagesComponent extends AbstractScenarioPanelComponent {

  constructor(scenarioImageService: ScenarioImageService,
              doorService: DoorService,
              applicationStateService: ApplicationStateService,
              trackingService: TrackingService,
              qrCodeService: QrCodeService,
              router: Router,
              customerService: CustomerService,
              doorTypeValidationService: DoorTypeValidationService,
              ) {
    super(scenarioImageService, doorService, applicationStateService, trackingService, qrCodeService, router, customerService, doorTypeValidationService);
  }
}
